module.exports = __webpack_public_path__ + "cd00c81b95570887a0af4fafe1d1bfb3.png";